import React, { Component, Fragment } from "react";

export default class FormMetasMensais extends Component {

    constructor(props) {
        super(props);

        this.state = {
            resumoMeta: {}
        }

    }

    async componentDidMount() {
        let path = window.location.pathname;
        path = path.split("mensais-");
        path = path[path.length - 1];
        await this.props.loadMetas(path);
    }

    getDefaultData = (data, key) => {
        let defaultDate = data !== undefined ? data : `2027-${(key+1).toString().padStart(2, '0')}`
        return defaultDate
    }

    getDefaultValue = (meta, campo, key) => {
        
        let value = meta[campo][key]
        if(['dataFim'].includes(campo)) {
            value = this.getDefaultData(value, key)
        }

        return value

    }

    isVisibleResidual = (tipo, key) => {
        let visibility =  tipo === 'Residual' && key > 0 ? true : false
        return visibility
    }

    render() {
        let { metas, meses, unidade, curso, tipo } = this.props;
        return (
            curso === '' ?
            null
            :
            <Fragment>
                {/* <form onSubmit={this.props.onSubmit} id="formMetasMensais"> */}
                <div className="col-md-12">
                    <div className="card card-user">
                        <div className="card-header">
                            {/* <div className="row">
                                <div className="col-md-12"> */}
                                    
                                {/* </div>
                            </div> */}
                        </div>
                        <div className="card-body">
                            
                            <table className="mb-2">
                                <thead>
                                    <tr>
                                        <th>Mês</th>
                                        <th scope="col">N.° de Turmas</th>
                                        <th scope="col">N.º de Alunos Turmas</th>
                                        <th scope="col">Carga Horária</th>
                                        <th scope="col">Mat. Residuais</th>
                                        <th scope="col" title="N.° de Turmas * N.º de Alunos Turmas">Mat. Novas</th>
                                        <th scope="col" title="Mat. Residuais + Mat. Novas">Total Mat.</th>
                                        <th scope="col" title="Carga Horária * Total Mat.">Hora/aluno</th>
                                        <th scope="col" title="Carga Horária * Total Mat.">Hora/aluno Distribuida</th>
                                        {/* <th scope="col" className="hidden-element" title="N.° de Turmas * Carga Horária">Carga H. Turma/Ano</th>
                                        <th scope="col" className="hidden-element" title="Carga H. Turma/Ano / 200 / 8">Necessidade de docente (8h)</th>
                                        <th scope="col" className="hidden-element" title="Carga H. Turma/Ano / 200 / 7,2">Necessidade de docente (7,2h)</th> */}
                                        {/* <th scope="col" title="Carga Horária * Total Mat.">Data Início</th> */}
                                        <th scope="col" title="Carga Horária * Total Mat.">Data Fim</th>
                                    </tr>
                                </thead>
                                <tbody onChange={this.props.onChange}>
                                    {meses.map((mes, key) => {
                                        return (
                                            // <tr key={key} style={this.props.isVisibility(key)}>
                                            <tr key={key} style={this.props.isVisibility(key)}>
                                                <th scope="row">{mes}</th>
                                                <td scope="col"><input type="text" className="numTurmas" name="numTurmas" defaultValue={this.getDefaultValue(metas, 'numTurmas', key)} disabled={ this.isVisibleResidual(tipo, key) } /></td>
                                                <td scope="col"><input type="text" className="numAlunosTurmas" name="numAlunosTurmas" defaultValue={this.getDefaultValue(metas, 'numAlunosTurmas', key)} disabled={ this.isVisibleResidual(tipo, key)} /></td>
                                                <td scope="col"><input type="text" className="cargaHoraria" name="cargaHoraria" defaultValue={this.getDefaultValue(metas, 'cargaHoraria', key)} disabled={ this.isVisibleResidual(tipo, key)} /></td>
                                                <td scope="col"><input type="text" className="numMatriculasResiduais" name="numMatriculasResiduais" defaultValue={this.getDefaultValue(metas, 'numMatriculasResiduais', key)} readOnly /></td>
                                                <td scope="col"><input type="text" className="numMatriculasNovas" name="numMatriculasNovas" defaultValue={this.getDefaultValue(metas, 'numMatriculasNovas', key)} readOnly /></td>
                                                <td scope="col"><input type="text" className="numTotalMatriculas" name="numTotalMatriculas" defaultValue={this.getDefaultValue(metas, 'numTotalMatriculas', key)} /></td>
                                                <td scope="col"><input type="text" className="horaAluno" name="horaAluno" defaultValue={this.getDefaultValue(metas, 'horaAluno', key)} /></td>
                                                <td scope="col"><input type="text" className="horaAlunoDistribuida" name="horaAlunoDistribuida" defaultValue={this.getDefaultValue(metas, 'horaAlunoDistribuida', key)} /></td>
                                                {/* <td scope="col" className="hidden-element"><input type="text" className="cargaHorariaTurmaAno" name="cargaHorariaTurmaAno" defaultValue={metas.cargaHorariaTurmaAno[key]} /></td>
                                                <td scope="col" className="hidden-element"><input type="text" className="necessidadeDocente8H" name="necessidadeDocente8H" defaultValue={metas.necessidadeDocente8H[key]} /></td>
                                                <td scope="col" className="hidden-element"><input type="text" className="necessidadeDocente7H" name="necessidadeDocente7H" defaultValue={metas.necessidadeDocente7H[key]} /></td> */}
                                                {/* <input type="hidden" className="horaAluno" name="horaAluno" defaultValue={metas.horaAluno[key]} /> */}
                                                <input type="hidden" className="cargaHorariaTurmaAno" name="cargaHorariaTurmaAno" defaultValue={this.getDefaultValue(metas, 'cargaHorariaTurmaAno', key)} />
                                                <input type="hidden" className="necessidadeDocente8H" name="necessidadeDocente8H" defaultValue={this.getDefaultValue(metas, 'necessidadeDocente8H', key)} />
                                                <input type="hidden" className="necessidadeDocente7H" name="necessidadeDocente7H" defaultValue={this.getDefaultValue(metas, 'necessidadeDocente7H', key)} />
                                                <input type="hidden" className="dataInicio" name="dataInicio" defaultValue={`2027-${(key+1).toString().padStart(2, '0')}`} />
                                                <td scope="col"><input type="month" className="dataFim" name="dataFim" defaultValue={this.getDefaultValue(metas, 'dataFim', key)} /></td>
                                            </tr>
                                        )
                                    })}
                                    <tr>
                                        <th scope="row">TOTAL</th>
                                        <td scope="col"><input type="text" className="totalNumTurmas" id="totalNumTurmas" defaultValue={metas.total[0]} /></td>
                                        <td scope="col"><input type="text" className="totalNumAlunosTurmas" id="totalNumAlunosTurmas" defaultValue={metas.total[1]} /></td>
                                        <td scope="col"><input type="text" className="totalCargaHoraria" id="totalCargaHoraria" defaultValue={metas.total[2]} /></td>
                                        <td scope="col"><input type="text" className="totalNumMatriculasResiduais" id="totalNumMatriculasResiduais" defaultValue={metas.total[3]} /></td>
                                        <td scope="col"><input type="text" className="totalNumMatriculasNovas" id="totalNumMatriculasNovas" defaultValue={metas.total[4]} /></td>
                                        <td scope="col"><input type="text" className="totalNumTotalMatriculas" id="totalNumTotalMatriculas" defaultValue={metas.total[5]} /></td>
                                        <td scope="col"><input type="text" className="totalHoraAluno" id="totalHoraAluno" defaultValue={metas.total[6]} /></td>
                                        <td scope="col"><input type="text" className="totalHoraAlunoDistribuida" id="totalHoraAlunoDistribuida"  /></td>
                                        {/* <td scope="col" className="hidden-element"><input type="hidden" className="totalCargaHorariaTurmaAno" id="totalCargaHorariaTurmaAno" defaultValue={metas.total[7]} /></td>
                                        <td scope="col" className="hidden-element"><input type="hidden" className="totalNecessidadeDocente8H" id="totalNecessidadeDocente8H" defaultValue={metas.total[8]} /></td>
                                        <td scope="col" className="hidden-element"><input type="hidden" className="totalNecessidadeDocente7H" id="totalNecessidadeDocente7H" defaultValue={metas.total[9]} /></td> */}
                                        {/* <input type="hidden" className="totalHoraAlunoACC" name="totalHoraAlunoACC" defaultValue={metas.total[6]} /> */}
                                        <input type="hidden" className="totalCargaHorariaTurmaAno" id="totalCargaHorariaTurmaAno" defaultValue={metas.total[7]} />
                                        <input type="hidden" className="totalNecessidadeDocente8H" id="totalNecessidadeDocente8H" defaultValue={metas.total[8]} />
                                        <input type="hidden" className="totalNecessidadeDocente7H" id="totalNecessidadeDocente7H" defaultValue={metas.total[9]} />
                                        {/* <td scope="col"><input type="date" className="dataInicio" id="dataInicio" defaultValue={metas.total[6]} /></td>
                                        <td scope="col"><input type="date" className="dataFim" id="dataFim" defaultValue={metas.total[6]} /></td> */}
                                    </tr>
                                </tbody>
                            </table>

                            <div className="col-md-12 m-2" style={{ display: "flex" }}>
                                <button type="submit" className="btn btn-primary btn-round ml-auto">Cadastrar</button>
                            </div>

                        </div>
                    </div>
                </div>
                {/* </form> */}
            </Fragment>
        )
    }
}